import React, { useState, useEffect } from "react";
import { Configurations } from "../../../Utils/Configurations";
import './Cile-Content.scss';
import axios from "axios";
import { withRouter } from 'react-router-dom';
import moment from "moment";

const CileContentReviewDetails = (props) => {

    const [loading, setLoading] = useState(false)
    const [livros, setLivros] = useState([])

    const [formState, setFormState] = useState(props.location.state ? {
        titulo: props.location.state.titulo,
        resumo: props.location.state.resumo,
        pdf: props.location.state.pdf,
        link: props.location.state.link,
        livro: props.location.state.books_id,
    } : {
        titulo: '',
        resumo: '',
        pdf: '',
        link: '',
        livro: ''
    })

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormState((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    useEffect(() => {
        chamadaLivros()
    }, [])

    const chamadaLivros = () => {
        const config = new Configurations();
        axios.get(config.apiBasePath + `/conteudo-cile/livros/lista?limite=10&pagina=1`)
            .then(response => {
                setLivros(response.data.livros)
            })
            .catch(error => {
                console.log("ERROR: ", error)
            })
            .finally(() => {
                setLoading(false)
            });
    }

    const selectLivro = (id) => {
        setFormState((prevState) => ({
            ...prevState,
            livro: id,
        }));
    };

    const EditarResenha = () => {
        const config = new Configurations();
        const _body = {
            "titulo": formState.titulo,
            "resumo": formState.resumo,
            "pdf": formState.pdf,
            "link": formState.link,
        };

        axios.put(config.apiBasePath + `/conteudo-cile/resenhas/atualiza/${props.location.state.id}`, _body)
            .then(() => {
                setLoading(true)

            }).catch(error => {
                console.log("ERROR: ", error)
            })
            .finally(() =>
                window.history.go(-1)
            )
    }

    const AdicionarResenha = () => {
        const config = new Configurations();
        const _body = {
            "titulo": formState.titulo,
            "resumo": formState.resumo,
            "pdf": formState.pdf,
            "link": formState.link,
            "idLivro": formState.livro,
            "dtPublicacao": moment().format('YYYY-MM-DD'),
        };

        axios.post(config.apiBasePath + `/conteudo-cile/resenhas/novo`, _body)
            .then(() => {
                setLoading(true)

            }).catch(error => {
                console.log("ERROR: ", error)
            })
            .finally(() =>
                window.history.go(-1)
            )
    }

    const podeSalvar = () => {
 
        const tituloValido = !!formState.titulo && formState.titulo.trim() !== "";
         
        const resumoValido = !!formState.resumo && formState.resumo.trim() !== "";

        const linkValido = !!formState.link && formState.link.trim() !== "";

        const livroValido = !!formState.livro && formState.livro.trim() !== "";

         
        const fluxoEdicao = !!props.location.state;
         
        if (fluxoEdicao) {
             return false
        }else {
            return !tituloValido || !resumoValido || !linkValido || !livroValido
         }
        }


    return (
        <div className="cile-remessas">
            <div className="row">
                <div className="col-12 py-2">
                    <div className="row no-gutters align-items-center">
                        <div className="col-12 col-lg-8 text-center text-lg-left">
                            {props.location.state ?
                                <h2 className="title-1 d-none d-lg-block">CILE - Editar Resenha</h2>
                                :
                                <h2 className="title-1 d-none d-lg-block">CILE - Adicionar Resenha</h2>
                            }
                        </div>
                        <div className="col-12 col-lg-4 text-center text-lg-right">
                            <div className="row no-gutters">
                                <div className="col py-2 py-lg-0">
                                    <button onClick={() => window.history.go(-1)} className="btn btn-outline-secondary">voltar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="card">
                <div className="row no-gutters align-items-center px-3">
                    <div className='col-12 py-3'>
                        <label className="pl-2"><strong>Título:</strong></label>
                        <input name="titulo" type="text" className="form-control" autoComplete="off" value={formState.titulo} onChange={handleInputChange} />
                    </div>
                    {props.location.state ? null :
                        <div className='col-5 py-3'>
                            <label className="pl-2"><strong>Livro:</strong></label>

                            <select
                                id="livro"
                                name="selectLivro"
                                className="form-control"
                                value={formState.livro}
                                onChange={(e) => selectLivro(e.target.value)}
                            >
                                <option value="" disabled hidden>Selecione um livro</option>
                                {livros && livros.length > 0 &&
                                    livros.map((item) => (
                                        <option key={item.id} value={item.id}>
                                            {item.title}
                                        </option>
                                    ))
                                }

                            </select>
                        </div>
                    }
                    <div className="col-12 py-3">
                        <label className="pl-2"><strong>Resumo:</strong></label>
                        <textarea name="resumo" rows={5} className="w-100 form-control" value={formState.resumo} onChange={handleInputChange} />
                    </div>

                    {/* <div className='col-6 pb-2'>
                        <label>WordPress</label>
                        <input name="select-type" type="radio" id="wordpress" onChange={() => setIsPDF(false)} className="form-check-input ml-2" autoComplete="off" checked={!isPDF} />
                    </div>
                    <div className='col-6 pb-2'>
                        <label>PDF</label>
                        <input name="select-type" type="radio" id="pdf" onChange={() => setIsPDF(true)} className="form-check-input ml-2" autoComplete="off" />
                    </div> */}

                    <div className='col-12 pb-2'>
                        <label><strong>Link WordPress:</strong></label>
                        <input name="link" type="text" className="form-control" autoComplete="off" value={formState.link} onChange={handleInputChange} />
                    </div>

                    {props.location.state ?
                        <label ><strong>Nome do arquivo PDF: </strong>{props.location.state.pdf}</label>
                        :
                        null
                    }

                    {/* {isPDF ?
                        <div className='col-12 pb-2'>
                            {props.location.state.pdf ?
                                <label className="pl-2"><strong>Nome do arquivo PDF: </strong>{props.location.state.pdf}</label>
                                :
                                <>
                                    <label>Nome do arquivo PDF</label>
                                    <input name="link" type="text" className="form-control" autoComplete="off" value={formState.pdf} onChange={handleInputChange} />
                                </>
                            }

                        </div>

                        :
                        
                    } */}

                    {loading ?
                        <div className="spinner-border text-success" role="status" />
                        :
                        <div className='col-12 text-right py-2'>
                            <button className='btn btn-outline-success' disabled={podeSalvar()} onClick={() => props.location.state ? EditarResenha() : AdicionarResenha()}>
                                {props.location.state ? 'Salvar' : 'Incluir'}
                            </button>
                        </div>}

                </div>



            </div>


        </div>
    )
}


export default withRouter(CileContentReviewDetails);